<template>
  <grid-area-editor
    v-if="catalog === catalogValue.area"
    :type="type"
    :mode="mode"
    :value="editorValue"
    :parent-value="parentValue"
    :disabled-items="disabledItems"
    :hidden-items="hiddenItems"
    :allowed-items="options"
    @change="emitChange"
    class="grid-editor"
  />
  <grid-common-selector-editor
    v-else-if="catalog === catalogValue.date || catalog === catalogValue.time"
    :type="type"
    :mode="mode"
    :value="editorValue"
    :options="options"
    :disabled-items="disabledItems"
    :hidden-items="hiddenItems"
    @change="emitChange"
    class="grid-editor"
  >
  </grid-common-selector-editor>
  <grid-other-editor
    v-else-if="catalog === catalogValue.other"
    :type="type"
    :mode="mode"
    :value="editorValue"
    :options="options"
    :disabled-items="disabledItems"
    :hidden-items="hiddenItems"
    @change="emitChange"
    class="grid-editor"
  />
  <div v-else>不支持的输入模式</div>
</template>
<script>
import {
  Check,
  MultiSelector,
  NumberInput,
  SingleSelector,
  TextInput,
} from "@/components/excel/schema/label/mode";
import { ProvinceOption } from "@/components/excel/schema/label/type/area.ts";
import {
  CityOption,
  CountyOption,
} from "@/components/excel/schema/label/type/area";
import { YearOption } from "@/components/excel/schema/label/type/date.ts";
import {
  DayOption,
  MonthOption,
} from "@/components/excel/schema/label/type/date";
import { findCatalog } from "@/components/excel/schema/label/type";
import {
  AreaOption,
  DateOption,
  OtherCatalogOption,
  TimeOption,
} from "@/components/excel/schema/label/catalog";
import GridAreaEditor from "@/components/grid/editor/AreaSelector";
import GridOtherEditor from "@/components/grid/editor/OtherEditor";
import GridCommonSelectorEditor from "@/components/grid/editor/CommonSelectorEditor";
export default {
  name: "grid-editor",
  components: {
    GridCommonSelectorEditor,
    GridOtherEditor,
    GridAreaEditor,
  },
  props: {
    parentCell: Object,
    type: Number,
    mode: Number,
    value: [Array, Number, String, Boolean],
    parentValue: [Array, Number, String, Boolean],
    options: Array,
    disabledItems: Array,
    hiddenItems: Array,
  },
  data() {
    return {
      provinceSource: [],
      modeValue: {
        single: SingleSelector.value,
        multi: MultiSelector.value,
        text: TextInput.value,
        check: Check.value,
        number: NumberInput.value,
      },
      optionValue: {
        province: ProvinceOption.value,
        city: CityOption.value,
        county: CountyOption.value,
        year: YearOption.value,
        month: MonthOption.value,
        day: DayOption.value,
      },
      catalogValue: {
        area: AreaOption.value,
        date: DateOption.value,
        time: TimeOption.value,
        other: OtherCatalogOption.value,
      },
    };
  },
  computed: {
    catalog() {
      const catalog = findCatalog(this.type);
      if (catalog) {
        return catalog.value;
      }
      return null;
    },
    editorValue() {
      return this.value;
    },
  },
  methods: {
    emitChange(value) {
      // console.log(value);
      this.$emit("change", value);
    },
  },
};
</script>
